var mp = mp || {};

// TypeHead
//-----------------------------------------------------------------
mp.typeHead = function() {

    var $element = $('.typeahead');
    if (!$element.length) {
        return;
    }

    $.get("ajax/get-users", function(data){
        $element.typeahead({
            minLength: 0,
            autoSelect: true,
            source: data,
        });
    },'json');

    

    $element.change(function() {
        var $current = $element.typeahead("getActive");
        if ($current) {
            if ($current.name == $element.val()) {

                $.each($current, function(i, value) {
                    if (i!="name"){
                        $('input[name="'+i+'"]').val(value);
                    }
                });​

            } else {
                $element.val("");
            }
        } else {
            $element.val("");
        }
    });

};



$(document).ready(function (){
    mp.typeHead();
});